import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ServiceType } from '../../../types/resources/ServiceType';

export async function getService(user_id: string): Promise<{ service: ServiceType }> {
  const response = await partnerAdminFetch(`/partner_admins/services/${user_id}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
}
